import { MetricTypes, statusTypes } from '@/hooks/useSls';

// 上传类型
export type UploadType = 'image' | 'video';
// 上传状态
export type UploadStatus = 'click' | 'success' | 'fail';

// 上传埋点参数
export interface UploadMetricParams {
  // 文件
  file: File;
  // 类型
  type: UploadType;
  // 状态
  status: UploadStatus;
  // 开始时间
  startTime: number;
  // 错误
  error?: any;
  // 额外参数
  additionalParams?: {
    // 视频时长
    video_duration: number;
    // 其他参数
    [key: string]: any;
  };
}

/**
 * 统一的上传埋点上报函数
 * @param params UploadMetricParams
 * @param reportSlsData 上报函数
 */
export const reportUploadMetric = (
  params: UploadMetricParams,
  reportSlsData: (data: any[]) => void
) => {
  const {
    file,
    type,
    status,
    startTime,
    error,
    additionalParams = {}
  } = params;

  // 结束时间
  const endTime = Date.now();
  // 上传时长
  const duration = endTime - startTime;
  
  // 基础参数
  const baseEnvironment = {
    // 文件大小 单位：B
    file_size: file?.size,
    // 文件类型
    file_type: file?.type,
  };

  // 成功状态下的额外参数
  const successEnvironment = status === 'success' ? {
    // 上传时长
    upload_duration: duration,
    // 上传速率 单位：MB/s
    upload_speed: Number((file?.size / 1024 / 1024) / (duration / 1000)).toFixed(2)
  } : {};

  // 失败状态下的额外参数
  const failEnvironment = status === 'fail' ? {
    // 失败原因
    [MetricTypes.failReason]: error?.message || error?.code || '未知原因',
    // 上传时长
    upload_duration: duration
  } : {};

  // 环境参数
  const environment = {
    ...baseEnvironment,
    ...successEnvironment,
    ...failEnvironment,
    ...additionalParams
  };

  // console.log('environment', environment, type === 'image' ? MetricTypes.imageUploadStatus : MetricTypes.videoUploadStatus, statusTypes[status])

  reportSlsData([
    ['reportMetric', 
      type === 'image' ? MetricTypes.imageUploadStatus : MetricTypes.videoUploadStatus, 
      statusTypes[status]
    ],
    ['setEnvironment', environment]
  ]);
}; 